import { ICoreSearchRequestData } from '../common/search/ICoreSearchRequestData';
import { CRUDServiceType } from '../common/service/CRUDServiceType';
import { CoreRestCRUDService } from '../coreCommon/common/rest/CoreRestCRUDService';
import { ISSOEntityService, ISSOProviderPublicModel } from './ISSOEntityService';
import { ISSOCheckResult } from './interface/ISSOCheckResult';
import { ISSOEntityModel } from './interface/ISSOEntityModel';

export class RestSSOService extends CoreRestCRUDService<ISSOEntityModel> implements ISSOEntityService {
  constructor(private type: CRUDServiceType) {
    super();
  }

  getEndpoint(): string {
    const url = this.config.url.api[this.type];
    return `${url}/sso_provider`;
  }

  async check(providerId: string): Promise<ISSOCheckResult> {
    return await this.request()
      .url(`${this.getEndpoint()}/check`)
      .post({ id: providerId })
      .json<ISSOCheckResult>()
      .catch(this.handleError);
  }

  async publicSearch(searchRequest: ICoreSearchRequestData<ISSOProviderPublicModel>): Promise<ISSOProviderPublicModel[]> {
    return this.request()
      .url(`${this.getEndpoint()}/public/search`)
      .post(searchRequest)
      .json<ISSOProviderPublicModel[]>()
      .catch(this.handleError);
  }
}
